import Section from "../Section"
import styles from "./FAQ.module.scss"
import { ChevronDown, ChevronUp } from "react-feather"
import { Disclosure, Transition } from "@headlessui/react"

const FAQ = ({ data }) => {
  // console.log("FAQ", data)

  return (
    <Section
      teaser={data?.section_teaser}
      headline={data?.section_headline}
      subline={data?.section_subline}
      text={data?.section_text}
      links={data?.section_links}
    >
      <div className={styles.FAQ}>
        {data?.faq_items?.map((item, index) => (
          <div key={index} className={styles.entry}>
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button className={styles.question}>
                    <div className={"flex items-center justify-between"}>
                      <div>{item.question}</div>
                      <div className={styles.icon}>
                        {open ? <ChevronUp /> : <ChevronDown />}
                      </div>
                    </div>
                  </Disclosure.Button>

                  <Transition
                    enter="transition duration-200 ease-out"
                    enterFrom="transform opacity-0"
                    enterTo="transform opacity-200"
                    leave="transition duration-200 ease-out"
                    leaveFrom="transform opacity-200"
                    leaveTo="transform opacity-0"
                  >
                    <Disclosure.Panel
                      className={styles.answer}
                      dangerouslySetInnerHTML={{ __html: item.answer }}
                    />
                  </Transition>
                </>
              )}
            </Disclosure>
          </div>
        ))}
      </div>
    </Section>
  )
}

export default FAQ
